import React, { useState } from 'react';
import './Workshop.css';
import Modal from 'react-modal';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Importing the images with correct relative paths
import firstInductionPhoto from '../assets/workshop images/1st induction 2023.jpg';
import githubWorkshopPhoto from '../assets/workshop images/gitworkshop.jpg';
//import fullstackWorkshopPhoto from '../assets/codex-logo.png';

Modal.setAppElement('#root'); // For accessibility

const Workshop = () => {
  const [selectedWorkshop, setSelectedWorkshop] = useState(null);

  // Workshop data
  const workshops = [
    {
      id: 1,
      title: 'Induction 2023',
      date: 'Oct 8, 2023',
      brief: 'Establishment of Codex Crew',
      fullDetails: 'This workshop covers the basics of React.js, including components, state management, and hooks. You’ll learn how to create a dynamic and responsive web app from scratch.',
      image: firstInductionPhoto,
    },
    {
      id: 2,
      title: 'AI and Machine Learning',
      date: 'Oct 5, 2023',
      brief: 'A deep dive into AI and machine learning applications.',
      fullDetails: 'This workshop focuses on the latest AI and machine learning trends, covering topics like supervised learning, neural networks, and real-world AI use cases.',
      image: githubWorkshopPhoto,
    },
    // {
    //   id: 3,
    //   title: 'Fullstack Development Workshop',
    //   date: 'Aug 8, 2024',
    //   brief: 'An overview of modern fullstack development.',
    //   fullDetails: 'Learn about current web development technologies, including front-end and back-end frameworks, REST APIs, and responsive design.',
    //   image: fullstackWorkshopPhoto,
    // },
  ];

  const sliderSettings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 3000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1024, // Tablet size and below
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // Mobile size
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,  // Center the single slide on mobile
        },
      },
      {
        breakpoint: 480, // Small mobile devices
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const handleModalOpen = (workshop) => {
    setSelectedWorkshop(workshop);
  };

  const handleModalClose = () => {
    setSelectedWorkshop(null);
  };

  return (
    <section className="workshop-section" id="workshops">
      <h2 className="section-title">Workshops</h2>
      <Slider {...sliderSettings} className="workshop-slider">
        {workshops.map((workshop) => (
          <div 
            key={workshop.id} 
            className="workshop-card" 
            onClick={() => handleModalOpen(workshop)}
          >
            <img src={workshop.image} alt={workshop.title} className="workshop-image" />
            <h3>{workshop.title}</h3>
            <p>{workshop.date}</p>
            <p>{workshop.brief}</p>
          </div>
        ))}
      </Slider>

      {/* Modal */}
      {selectedWorkshop && (
        <Modal
          isOpen={true}
          onRequestClose={handleModalClose}
          className="workshop-modal"
          overlayClassName="modal-overlay"
        >
          <div className="modal-content">
            <button className="close-modal" onClick={handleModalClose}>
              &times;
            </button>
            <img src={selectedWorkshop.image} alt={selectedWorkshop.title} className="modal-image" />
            <h2>{selectedWorkshop.title}</h2>
            <p><strong>Date:</strong> {selectedWorkshop.date}</p>
            <p>{selectedWorkshop.fullDetails}</p>
          </div>
        </Modal>
      )}
    </section>
  );
};

export default Workshop;
